import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { ICalendarLevelExtra } from '../calendar-level'
import { HelperService } from '../../../services/helper.service'

interface ITooltipRow {
  tag: string
  value: string
}

interface ITooltipSection {
  level: string
  rows: ITooltipRow[]
}

@Component({
  selector: 'app-calendar-tooltip-table',
  templateUrl: './calendar-tooltip-table.component.html',
  styleUrls: ['./calendar-tooltip-table.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class CalendarTooltipTableComponent {
  @Input() data: ICalendarLevelExtra | null = null
  @Input() showTimestamp: boolean = true

  public get sections(): ITooltipSection[] {
    if (!this.data || !this.data.tooltip || typeof this.data.tooltip !== 'object') {
      return []
    }

    const keys: string[] = Object.keys(this.data.tooltip).sort()
    const sections: ITooltipSection[] = []

    keys.forEach((levelKey: string) => {
      const levelPayload: any = this.data.tooltip[levelKey]
      const tags: any = levelPayload && Array.isArray(levelPayload.tags) ? levelPayload.tags : []

      const rows: ITooltipRow[] = tags
        .map((entry) => ({
          tag: entry && entry.tag ? entry.tag : '',
          value: entry && entry.timestamp ? entry.timestamp : '',
        }))
        .filter((row) => row.tag || row.value)

      if (rows.length > 0) {
        sections.push({ level: levelKey, rows })
      }
    })

    return sections
  }

  public getTitleByLevel(level: string): string {
    switch (level) {
      case 'level_1':
        return 'High Level'
      case 'level_2':
        return 'Medium Level'
      case 'level_3':
        return 'Low Level'
      default:
        return 'Unknown Level'
    }
  }

  public getNiceDate(dateString: string): string {
    return HelperService.niceDate(dateString)
  }
}
